import { useCurrentUser } from 'hooks/useCurrentUser';
import { FF, useFeatureFlagEnabled } from 'modules/feature-flags';
import { WithApolloContext } from 'modules/Apollo/types';

/**
 * True when stickiness is disabled by the Split kill-switch or by the clinic
 * admin's featureSettings toggle. Defaults to false while clinic data loads.
 */
export const useIsFilterPersistenceDisabled = ({
  context,
  skip = false,
}: WithApolloContext & { skip?: boolean }): boolean => {
  const [isForceDisabled] = useFeatureFlagEnabled(FF.WORKLIST_STICKY_FILTERS_DISABLED);
  const { data, loading } = useCurrentUser({ context, skip });
  if (skip) return isForceDisabled;
  const isClinicEnabled = loading
    ? true
    : (data?.me?.clinic?.featureSettings?.worklistFilterPersistenceEnabled ?? true);
  return isForceDisabled || !isClinicEnabled;
};
